// Stability configurations routes
export default [
  {
    path: 'stability-configurations',
    name: 'stabilityConfigurations',
    redirect: 'stability-configurations/index',
    component: () =>
      import(
        /* webpackChunkName: "stability" */ '../views/stability/Stability.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'stabilityConfigurationsIndex',
        meta: {
          tabbable: true,
          tableKeys: ['stabilityConfigurations'],
          filterKeys: [],
          formKeys: [],
          routePermissions: ['stabilityConfigView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "stabilityList" */ '../views/stability/StabilityList.vue'
          ),
      },
      {
        path: ':id/configure',
        name: 'stabilityConfigurationsConfigure',
        meta: {
          menuActiveRouteName: 'stabilityConfigurationsIndex',
          routePermissions: ['stabilityConfigView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "stabilityConfiguration" */ '../views/stability/StabilityConfiguration.vue'
          ),
      },
      {
        path: 'schedule',
        name: 'stabilityScheduleIndex',
        meta: {
          tabbable: true,
          menuActiveRouteName: 'stabilityScheduleIndex',
          filterKeys: ['stabilitySchedule'],
          routePermissions: ['stabilityConfigView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "stabilitySchedule" */ '../views/stability/StabilitySchedule.vue'
          ),
      },
      {
        path: 'time-point-export',
        name: 'stabilityTimePointExportIndex',
        meta: {
          tabbable: true,
          menuActiveRouteName: 'stabilityTimePointExportIndex',
          formKeys: ['stabilityTimePointExport'],
          routePermissions: ['stabilityTimePointExport'],
        },
        component: () =>
          import(
            /* webpackChunkName: "stabilityTimePointExport" */ '../views/stability/StabilityTimePointExport.vue'
          ),
      },
    ],
  },
];
